import React, { useState } from 'react';
import { Paper, Box, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { format } from 'date-fns';
import { TaskStatus, TaskPriority } from '../../../../utils/enums'
import useApiManager from '../../../../utils/Api/apiManager';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationDialog from '../../../ConfirmationDialog/ConfirmationDialog';

const DeleteRow = ({ hover }) => (
    <Box sx={{ position: 'relative', width: '20px', height: '22px' }}>
        {hover && <DeleteIcon />}
    </Box>
);

const ClosedActivities = ({ data, fetchClosedTasks }) => {
    const { del } = useApiManager();
    const [hoveredRow, setHoveredRow] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentRow, setCurrentRow] = useState('');

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmAction = () => {
        handleDelete();
        handleCloseDialog();
    };

    const handleDelete = async () => {
        try {
            const deletedRow = await del(`/tasks/${currentRow.id}`);
            fetchClosedTasks();
        } catch (error) {
            console.error('Error deleting task:', error);
        }
    };

    return (
        <Paper elevation={0} sx={{ p: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                <h4>Closed Activities</h4>

            </Box>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell width={10}>-</TableCell>
                            <TableCell sx={{ maxWidth: 250 }}>Subject</TableCell>
                            <TableCell>Due Date</TableCell>
                            <TableCell>Task Owner</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Priority</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((row) => (
                            <TableRow
                                key={row.id}
                                onMouseEnter={() => setHoveredRow(row.id)}
                                onMouseLeave={() => setHoveredRow(null)}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <Tooltip title="Delete">
                                    <TableCell sx={{ width: '20px', height: '22px', padding: '8px', cursor: 'pointer' }}
                                        onClick={() => {
                                            setCurrentRow(row);
                                            handleOpenDialog();
                                        }}>
                                        <DeleteRow hover={hoveredRow === row.id} />
                                    </TableCell>
                                </Tooltip>
                                <TableCell component="th" scope="row" sx={{
                                    maxWidth: 250,
                                    wordWrap: 'break-word',
                                    whiteSpace: 'normal', // allow wrapping
                                }}>
                                    <Link to={`/tasks/${row.id}`}>{row.subject || 'No subject'}</Link>
                                </TableCell>
                                <TableCell>{row.dueDate ? format(new Date(row.dueDate), 'MMMM do yyyy') : 'No due date'}</TableCell>
                                <TableCell>{row.ownerName || 'No owner name'}</TableCell>
                                <TableCell>{TaskStatus?.[row.status]?.label || 'Unknown Status'}</TableCell>
                                <TableCell>
                                    {TaskPriority?.[row.priority]?.label || 'Unknown Priority'}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <ConfirmationDialog
                open={openDialog}
                title="Confirm Action"
                content="Are you sure you want to delete this item?"
                onClose={handleCloseDialog}
                onConfirm={handleConfirmAction}
                confirmText="Confirm"
                cancelText="Cancel"
            />
        </Paper>
    );
};

export default ClosedActivities;
